const BscTestnetAddresses = {
  ORACLE_ADDRESS: "0x3e2320C81FdB8919bC5771CBA897B9C683506140",
  FACTOR_REGISTRY_ADDRESS: "0x5d52F11eb60c3E7A301Dc45271Dc131D2D8025f7",
  POOL_LOGIC_ADDRESS: "0x867c92576b03d6719B43092e1708DA8Dc0919cB1",
  POOL_CONFIGURATOR_LOGIC_ADDRESS: "0x9cBC85752CC60f797406783600A32137C49dDB86",
  T_TOKEN_LOGIC_ADDRESS: "0xf23f7e228BD9c17D5B3489c782A7A638163720D1",
  DEBT_TOKEN_LOGIC_ADDRESS: "0x348bdD35e690b882bC8ECeBB0A2C4aBFFeDcD611",
  TREASURY_ADDRESS: "0x8db6383cb07336674e473E8205263B139Dd04481",
  INCENTIVES_ADDRESS: "0x8f5D5A6C9938d397be1f99F19dE7bF54B68210cb",
  TRAVA_TOKEN_ADDRESS: "0xeF9f0a317c4328585adBf0cEcfc410eFbE96a9a9",
  STAKED_TRAVA_TOKEN_ADDRESS: "0xD8c4d8FA8cf11b03d97222Edb8cab3d8AcC68576",
  GATEWAY_ADDRESS: "0x1552bE606C351c50CBF7D911290919ef28B8506a",
  POOL_UPDATE_CONTROLLER: "0xe924B58b404dbB458Df964ED5368b91155D83925",
  ADDRESS_PROVIDER_FACTORY: "0xD50355EC8F0bC43DaFd28E5c90e737f567598fd4",
};

export default BscTestnetAddresses;
